import React from "react";

export const LocationAndWorkforceTab = () => <div>LocationAndWorkforceTab</div>;
